export default function retrieveXmppCredentials() {
  const xmppLogin = window.localStorage.getItem("xmppLogin");
  const xmppPassword = window.localStorage.getItem("xmppPassword");

  if (!xmppLogin || !xmppPassword) {
    return null;
  }

  return {
    xmppLogin,
    xmppPassword
  };
}
